/* unplugin-vue-components disabled */import { render } from "./IntroInterests.vue?vue&type=template&id=016e5c68&scoped=true"
import script from "./IntroInterests.vue?vue&type=script&lang=js"
export * from "./IntroInterests.vue?vue&type=script&lang=js"

import "./IntroInterests.vue?vue&type=style&index=0&id=016e5c68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016e5c68"]])

export default __exports__